module.exports = __webpack_public_path__ + "img/IMG_9321_L_Foamcore_MockedUp.36747613.jpg";